module.exports = __webpack_public_path__ + "static/media/ceo_banner_cn.00562b3c.png";